<template>
  <div>
    <div class="deal-grid text-sm text-text-ternary bg-line rounded py-4">
      <div>Дата</div>
      <div>Тикер</div>
      <div>Тип бумаги</div>
      <div>Событие</div>
      <div class="text-right">Кол-во</div>
      <div class="text-right">Цена <!--, {{ portfolioCurrency.symbol }}-->
      </div>
      <div class="text-right">Комиссия <!--, {{ portfolioCurrency.symbol }}-->
      </div>
      <div class="text-right">Сумма, {{ portfolioCurrency.symbol }}</div>
      <div></div>
    </div>
    <div class="divide-y divide-line pt-px">
      <DealsListItem v-for="(deal,i) in deals" :deal="deal" :key="i"/>
    </div>
  </div>
</template>

<script>
import DealsListItem from "@/components/cabinet/Investments/InvestmentDeals/DealListItem/DealsListItem";
import {mapGetters, mapState} from "vuex";

export default {
  name: "DealsList",
  components: {DealsListItem},
  props: {
    deals: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('investments/portfolios', ['portfolioCurrency']),
  }
}
</script>
<style lang="scss">
.deal-grid {
  @apply grid col-gap-8 -mx-6 px-6;
  // Фиксированные колонки: Дата (120px), Событие (120px), Действия (48px)
  // Гибкие колонки: Тикер, Тип бумаги, Кол-во, Цена, Комиссия, Сумма
  grid-template-columns: 100px minmax(80px, 1fr) minmax(100px, 1fr) 120px minmax(60px, 0.8fr) minmax(100px, 1.2fr) minmax(100px, 1fr) minmax(120px, 1.2fr) 48px;
}
</style>